import { render, staticRenderFns } from "./PositionBelowFixed.vue?vue&type=template&id=4dc41d01&"
import script from "./PositionBelowFixed.vue?vue&type=script&lang=js&"
export * from "./PositionBelowFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports